import { PeopleTypes } from "enums/peopleTypes";
import { useFetchPublishedSeasonRoster } from "hooks/useSeasonRosterApi";
import { useFetchPublishedSeasonStaff } from "hooks/useSeasonStaffApi";
import { useSeasonRosterColumns } from "./useSeasonRosterColumns";
import { useSeasonStaffColumns } from "./useSeasonStaffColumns";

type Props = {
  type: PeopleTypes;
  entityId: string;
  seasonId: string;
  enabled: boolean;
};

export const usePreviewPeople = ({ type, entityId, seasonId, enabled }: Props) => {
  const { data: rosterResponse, isLoading: isRosterLoading } = useFetchPublishedSeasonRoster({
    entityId,
    seasonId,
    enabled: type === PeopleTypes.Roster && enabled,
  });

  const { data: staffResponse, isLoading: isStaffLoading } = useFetchPublishedSeasonStaff({
    entityId,
    seasonId,
    enabled: type === PeopleTypes.Staff && enabled,
  });

  const rosterColumns = useSeasonRosterColumns({
    viewOnly: true,
    editMode: false,
  });
  const staffColumns = useSeasonStaffColumns({
    viewOnly: true,
    editMode: false,
  });

  return {
    isLoading: isRosterLoading || isStaffLoading,
    records:
      type === PeopleTypes.Roster
        ? rosterResponse?.data || []
        : type === PeopleTypes.Staff
          ? staffResponse?.data || []
          : [],
    columns: type === PeopleTypes.Roster ? rosterColumns : type === PeopleTypes.Staff ? staffColumns : [],
  };
};
